import { OfferSubscriptionsScreen } from "./offer-subscriptions.screen";
import { Paths } from "../../routes/paths";
import { type RouteDefinition } from "../../routes/route-definition";

export const OfferSubscriptionsRoutes: RouteDefinition[] = [
	{
		path: Paths.offerSubscriptions.path,
		element: <OfferSubscriptionsScreen />,
		requiredPermissions: ["UserInAccountPermission_Nodes_ReadNodes"],
	},
];
